<template>
    <login-form-position :show-login-form="isStayPage">
        <v-alert
            ref="auth-notice"
            v-model="anyNotice"
            dismissible
            type="success"
            class="elevation-12 shape cutie text-caption"
        >
            {{ anyNoticeMessage }}
        </v-alert>
        <alert-error id="errorMessage" v-model="error" :title="errorMessage" dismissible class="elevation-12" />
        <the-node-saml-login-tab
            v-if="isCreated"
            :domain-name="domainName"
            :saml-enabled="samlEnabled"
            :account-lock="isAccountLock"
            :verification-mail="isVerificationMail"
            :is-multi-auth="isMultiAuth"
            :mail-menu="mailDialogMenu"
            :auto-saml-login="isSiteUser"
        />
        <node-saml-post-sender :session-id="session_id" :relay-state="relay_state" :auto="!isNodeAccount" />
    </login-form-position>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { useUsrSettingStore } from '../../../store/modules/user_setting/composables';
import { useAuthStore } from '../../../store/modules/auth/composables';
import { useNodeSamlStore } from '../../../store/modules/auth/node_saml/composables';
import { AlertError } from '../../atoms';
import { TheNodeSamlLoginTab, NodeSamlPostSender, LoginFormPosition } from '../../organisms';
import { useLoginPageLogic } from './composable/LoginPage';
import { useRoute } from 'vue-router/composables';

/*
 * composables
 */
const {
    anyNotice,
    anyNoticeMessage,
    anyError,
    anyErrorMessage,
    domainName,
    samlEnabled,
    isAccountLock,
    isVerificationMail,
    isMultiAuth,
    mailDialogMenu,
} = useLoginPageLogic();
const { beforeLogin } = useUsrSettingStore();
const { amIAuthed } = useAuthStore();
const route = useRoute();
const { acsRedirectDataState } = useNodeSamlStore();

/*
 * setter, getters
 */
const isCreated = ref(false);
const session_id = (document.getElementsByName('node-saml-session')[0] as any).value;
const relay_state = (document.getElementsByName('relay-state')[0] as any).value;
const isNodeAccount = (document.getElementsByName('is-node-account')[0] as any).value === 'true';
const isSiteUser = (document.getElementsByName('is-site-user')[0] as any).value === 'true';
const error = computed(() => anyError.value || acsRedirectDataState.value.error);
const errorMessage = computed(() => {
    if (anyError.value) {
        return anyErrorMessage.value;
    } else if (acsRedirectDataState.value.error) {
        return `${acsRedirectDataState.value.errorCode} - ${acsRedirectDataState.value.errorMsg}`;
    }
    return '';
});
const isStayPage = computed(() => isNodeAccount && !isSiteUser); // 次の画面へ自動移動しないかどうか

/**
 * lifecycle hooks
 */
if (!amIAuthed.value && isNodeAccount) {
    // 認証済み、もしくは、ノードに所属するIdPアカウントでない場合は、次のページに移動するので不要な処理をスキップ
    beforeLogin(); // 認証済みで呼ぶとエラーになる
    isCreated.value = true; // スキップしないとき表示させる
}
</script>
